var _g;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgPricingArrow = function SvgPricingArrow(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Modal Open Close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.88 9.79006L12 13.6701L8.11998 9.79006C7.72998 9.40006 7.09998 9.40006 6.70998 9.79006C6.31998 10.1801 6.31998 10.8101 6.70998 11.2001L11.3 15.7901C11.69 16.1801 12.32 16.1801 12.71 15.7901L17.3 11.2001C17.69 10.8101 17.69 10.1801 17.3 9.79006C16.91 9.41006 16.27 9.40006 15.88 9.79006Z",
    fill: "#333333"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPricingArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pricing-arrow.23561ad3.svg";
export { ForwardRef as ReactComponent };